// initial state
const state = {
    items: [],
    active: false
}

const getters = {
    itemsCount: state => {
        return 'hello'
    }
}

// actions
const actions = {
    addProductToCart({state, commit}, product) {
        const cartItem = state.items.find(item => item.part_no === product.part_no)
        if (!cartItem) {
            commit('pushProductToCart', product)
            commit('activateCart')
        } else {
            // commit('incrementItemQuantity', cartItem.code)
        }
    },
    modifyItemQuantity({state, commit}, {part_no, quantity}) {
        commit('modifyItemQuantity', {
            id: part_no,
            quantity
        })
    },
    removeItemFromCart({state, commit}, part_no) {
        commit('removeItem', part_no)
    },
    clearCart({state, commit}) {
        commit('clearCart')
    }
}

// mutations
const mutations = {
    pushProductToCart(state, product) {
        state.items.push({
            id: product.id,
            part_no: product.part_no,
            description: product.description,
            explanation: product.explanation,
            uom: product.uom,
            picture: product.thumbnail,
            mtmlUom: product.mtml_uom,
            quantity: 1
        })
    },

    incrementItemQuantity(state, id) {
        const cartItem = state.items.find(item => item.part_no === id)
        cartItem.quantity++
    },

    modifyItemQuantity(state, {id, quantity}) {
        const cartItem = state.items.find(item => item.part_no === id)
        cartItem.quantity = quantity
    },

    removeItem(state, id) {
        const cartItemIndex = state.items.findIndex(item => item.part_no === id)
        state.items.splice(cartItemIndex, 1)
    },
    activateCart(state) {
        state.active = true
    },
    clearCart(state) {
        state.items = [];
    }
}


export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}